import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import {
    FuseNavigationItem,
    FuseNavigationService,
} from "@fuse/components/navigation";
import { FuseMediaWatcherService } from "@fuse/services/media-watcher";
import { Store } from "@ngrx/store";
import { LOCAL_STORAGE_KEYS } from "app/core/constants/local-storage-keys";
import { Form } from "app/core/models/form";
import { FormsService } from "app/core/services/forms.service";
import { LocalStorageService } from "app/core/services/local-storage.service";
import { AppState } from "app/core/store/reducers/app.reducer";
import { selectProject } from "app/core/store/selectors";
import _ from "lodash";

@Component({
    selector: "app-left-vertical-navigation",
    templateUrl: "./left-vertical-navigation.component.html",
    styleUrls: ["./left-vertical-navigation.component.scss"],
})
export class LeftVerticalNavigationComponent implements OnInit {
    @Input()
    leftNavigationOpen = false;
    @Output()
    openedChanged = new EventEmitter<boolean>();
    forms: Form[];
    filteredForms: Form[];
    groupedForms: any;
    leftNavigation: FuseNavigationItem[] = [
        {
            id: "forms",
            title: "Forms",
            type: "collapsable",
            icon: "remove",
            children: [],
        },
    ];
    mediaWatchSub: any;
    isScreenSmall: boolean;

    constructor(
        private formsService: FormsService,
        private localStorage: LocalStorageService,
        private store: Store<AppState>,
        private fuseMediaWatcherService: FuseMediaWatcherService
    ) {
        this.formsService.list().subscribe((response) => {
            this.forms = response;

            this.store.select(selectProject).subscribe((selectedProject) => {
                this.filteredForms = this.forms.filter(
                    (y) =>
                        selectedProject.code == "All" ||
                        y.project.code == "All" ||
                        y.project.code == selectedProject.code
                );

                this.filteredForms = _.sortBy(this.filteredForms, [
                    "department",
                    "title",
                ]);

                this.groupedForms = _.chain(this.filteredForms)
                    .groupBy("department")
                    .map((value, key) => ({ department: key, forms: value }))
                    .value();

                let navigation: FuseNavigationItem[] = this.groupedForms.map(
                    (formGroup) => {
                        return {
                            id: formGroup.department,
                            title: formGroup.department,
                            type: "collapsable",
                            icon: "remove",
                            children: formGroup.forms.map((form) => {
                                return {
                                    id: form.id,
                                    title: form.title,
                                    type: "basic",
                                    icon: form.icon ?? "edit",
                                    link: `/project/${selectedProject.code.toLocaleLowerCase()}/${
                                        form.code
                                    }/home`,
                                    projectCode: form.project.code,
                                };
                            }),
                        };
                    }
                );

                this.leftNavigation = navigation;
            });
        });
    }

    ngOnInit(): void {
        this.mediaWatchSub =
            this.fuseMediaWatcherService.onMediaChange$.subscribe(
                ({ matchingAliases }) => {
                    this.isScreenSmall = !matchingAliases.includes("md");
                }
            );
    }

    ngOnDestroy() {
        this.mediaWatchSub?.unsubscribe();
    }
}
